import React, { useState } from 'react';
import Menu from '@mui/material/Menu';

//images
import menuIcon from '../../../../assets/img/icons/table-menu.png';
import editIcon from '../../../../assets/img/icons/edit.svg';
import deleteIcon from '../../../../assets/img/icons/delete.svg';
import { trans } from '../../../../_providers/Translation';

function Index(props) {

    const [table, setTable] = useState({
        options: null
    });

    const handleTableMenu = e => {

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        });
    };

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        });
    };

    const handleSend = id => {
        handleCloseMenu();

        props.handleSend(id);
    }

    const handleDownload = id => {
        handleCloseMenu();

        props.handleDownload(id);
    }

    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >

                <div className="menu-option" onClick={() => handleDownload(props.id)}>
                    <img src={editIcon} alt="edit" />
                    {trans('options.downloadRecord')}
                </div>
                <div className="menu-option" onClick={() => handleSend(props.id)}>
                    <img src={editIcon} alt="delete" />
                    {trans('options.sendRecord')}
                </div>
            </Menu>
        </>
    )
}

export default Index;
